<script lang="ts">
  import { page } from '$app/stores';
  import { browser } from '$app/environment';
  import '../app.css';
  import { SubscribePaymentService } from '@centerhealth/fe/subscribe';
  import { setContext } from 'svelte';
  import { writable } from 'svelte/store';
  import { CoreLayout } from '@centerhealth/fe/center-kit';
  import { config } from '@centerhealth/fe/config';

  const paymentService = new SubscribePaymentService();
  let preloadContainer: HTMLDivElement;
  let cardElement: HTMLDivElement;

  const getPaymentService = () => paymentService;
  const getPreloadContainer = () => preloadContainer;

  // Creation of signal to communicate Stripe was initialized and mounted
  const stripePrepared = writable(false);
  setContext('stripePrepared', stripePrepared);

  // Shares the preloaded "paymentService" from layout to Checkout
  setContext('paymentService', getPaymentService);
  setContext('preloadContainer', getPreloadContainer);

  const STRIPE_PUB_KEY = config.stripe.key;

  const stripeKey: string = STRIPE_PUB_KEY;

  $: {
    if (browser && $page.url) {
      // A scroll to top fix for svelte latest version, timer at 0
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }

  // mounts Stripe in hidden input field before Checkout
  const mountStripe: any = async (cardElement) => {
    await paymentService.initStripe(stripeKey);
    paymentService.mountField(cardElement);
    stripePrepared.set(true);
  };
</script>

<CoreLayout>
  {#if $page.url.pathname === '/subscribe' || $page.url.pathname === '/checkout' || $page.url.pathname === '/payment'}
    <div bind:this={preloadContainer} class="hidden">
      <div
        use:mountStripe
        bind:this={cardElement}
        id="card-element"
        class="input StripeElement StripeElement--focus"
      />
    </div>
  {/if}
  <slot />
</CoreLayout>

<style>
  #card-element.input {
    @apply text-base bg-white outline-none overflow-hidden h-[50px] w-full rounded-lg border-[1px] border-solid border-[#e1e4e6] py-[13px] px-[10px] text-[#555];
  }
</style>
